import Selector from "./components/Selector/Selector";
import { getLinks } from "./data/links";
import "./App.scss";

export namespace AppTypes {
  export type Props = {
    logoProduct?: string;
    imageProduct?: string;
    linkAppGooglePlay?: string;
    linkAppAppleStore?: string;
    linkVideoYouTube?: string;
    linkCecotecSupport?: string;
  };
}

export default function App(props: AppTypes.Props) {
  const {
    logoProduct = "%logoProduct%",
    imageProduct = "%imageProduct%",
    linkAppGooglePlay = "%linkAppGooglePlay%",
    linkAppAppleStore = "%linkAppAppleStore%",
    linkVideoYouTube = "%linkVideoYouTube%",
    linkCecotecSupport = "%linkCecotecSupport%",
  } = props;
  const links = getLinks({
    linkAppGooglePlay,
    linkAppAppleStore,
    linkVideoYouTube,
    linkCecotecSupport,
  });

  return (
    <div className="app landing-product-qr">
      <div className="gradient" />

      <div className="header">
        {logoProduct && (
          <img src={logoProduct} className="img-logo" alt="img-logo" />
        )}
        {imageProduct && (
          <img src={imageProduct} className="img-product" alt="img-product" />
        )}
      </div>

      <div className="content">
        {links.map((item, index) => (
          <Selector key={index} {...item} />
        ))}
      </div>

      <footer className="footer">
        <p className="text">www.cecotec.es</p>
      </footer>
    </div>
  );
}
